import React, {Component} from 'react';
import NotificationSystem from 'react-notification-system';

const NOTIFICATION_TIMEOUT = 5;

class Notice extends Component {
    static instants;

    constructor(props) {
        super(props);
        Notice.instants = this;
    }

    componentDidMount() {
        this.notificationSystem = this.refs.notificationSystem;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.generalError && nextProps.generalError !== this.props.generalError) {
            this.addNotification(
                nextProps.generalError,
                'error'
            )
        }
    }

    static addNotification(message, type) {
        Notice.instants.addNotification(message, type);
    }

    addNotification(message, type) {
        this.notificationSystem.addNotification({
            autoDismiss: NOTIFICATION_TIMEOUT,
            message: message,
            level: type
        });
    }

    render() {
        return (
            <NotificationSystem ref="notificationSystem" noAnimation={true}/>
        );
    }


}

export default Notice;


// WEBPACK FOOTER //
// ./src/components/Notification/newNotification.js